export const ContractTypes = ["SOW", "Consultant Agreement", "NDA"]
